import { AvMicroserviceApi } from '@availity/api-axios';
import envVar from '@availity/env-var';

import { getBaseAvUrl } from '@/global';

// NOTE: need to force the -apps domain for these API calls in the event that FR UI is accessed from AWS
// the current on-prem url prefix for FR UI. AWS url prefix commented out for now until AWS nav is ready.
const baseAvUrl = getBaseAvUrl();

const RegistrationAdministrationApi = new AvMicroserviceApi({
  url: baseAvUrl,
  name: 'registration-administration/v1/',
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'X-Client-ID': envVar({
      prod: 'c1272e00-6612-4cbb-a16e-8d9029ea7024',
      local: 'a65f9098-229d-4029-8dcc-93106b6e2d43',
    }),
  },
});

export async function getOaaOrgs(config) {
  const response = await RegistrationAdministrationApi.query({ ...config, id: 'oaa/get' });

  return response.data;
}

export async function saveOaaOrgs(data, config) {
  const response = await RegistrationAdministrationApi.post(data, { ...config, id: 'oaa/save' });

  return response.data;
}
